



























import {
  computed,
  defineComponent,
  ref,
  useFetch,
  useFetchState,
  useRouter
} from '~/utils/nuxt3-migration'
import PromotionsBanner from '~/components/car/banners/PromotionsBanner.vue'
import CContentSlider from '~/components/shared/configurable/CContentSlider.vue'
import { useNamespacedStore } from '~/compositions/store'
import {
  USER_AGENT_NS,
  UserAgentState
} from '~/store/modules/shared/userAgent/state'
import { shuffleArray } from '~/utils/array'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'
import { useAnalytics } from '~/compositions/analytics'
import FinanceBanner from '~/components/car/banners/FinanceBanner.vue'
import AuditsBanner from '~/components/car/banners/AuditsBanner.vue'
import PerksBanner from '~/components/car/banners/PerksBanner.vue'
import InhouseAdsBanner from '~/components/car/banners/InhouseAdsBanner.vue'
import WantedPartsBanner from '~/components/car/banners/WantedPartsBanner.vue'
import RouteGuardService from '~/services/RouteGuardService'
import { useDeps } from '~/compositions/dependency-container'
import PopularityService from '~/services/popularity/PopularityService'

export default defineComponent({
  components: {
    CContentSlider,
    PromotionsBanner,
    FinanceBanner,
    AuditsBanner,
    PerksBanner,
    InhouseAdsBanner,
    WantedPartsBanner
  },
  setup() {
    const router = useRouter()

    const isMobile = computed(() => userAgentGetters('isMobile'))
    const sliderRef = ref(null)
    const { getters: userAgentGetters } = useNamespacedStore<UserAgentState>(
      USER_AGENT_NS
    )

    const [routeGuardService, popularityService] = useDeps(
      RouteGuardService,
      PopularityService
    )
    const recordedPopularityEvents = ref([])
    const slides = useFetchState('slides', ref<string[]>([]))
    const { getters: userGetters } = useNamespacedStore<UserState>(USER_NS)
    const isSingleOrAnon = computed(() => userGetters('isSingleOrAnon'))
    const isOfTypeDealer = computed(() => userGetters('isOfTypeDealer'))
    const isAdmin = computed(() => userGetters('isAdmin'))
    const slideClasses = isMobile.value ? '!tw-h-[9.375rem]' : '!tw-h-40'

    const { state: userState } = useNamespacedStore<UserState>(USER_NS)

    const analytics = useAnalytics()
    const bannerClick = (
      bannerName: string,
      {
        event,
        path,
        dontUseRouter,
        openInNewTab,
        popularityEventName
      }: {
        event: any
        path: string
        dontUseRouter?: boolean
        openInNewTab?: boolean
        popularityEventName?: string
      }
    ) => {
      if (!path || sliderRef.value?.isDragging()) {
        return
      }

      analytics.recordEvent({
        namespace: 'n_index_banner_click',
        action: 'click',
        label: bannerName
      })

      if (popularityEventName) {
        recordPopularityEvent(bannerName, popularityEventName)
      }

      if (event) {
        event.preventDefault()
        if (event.ctrlKey) {
          window.open(path)
          return
        }
      }

      if (openInNewTab) {
        window.open(path)
        return
      }

      const routeExists = Boolean(router.resolve({ path }).route.matched.length)
      if (!routeExists || dontUseRouter) {
        window.location.href = path
        return
      }

      return router.push({ path }).catch(_e => {})
    }

    useFetch(() => {
      const dynamicDealerBanner = routeGuardService.userHasAccessToWantedParts()
        ? 'WantedPartsBanner'
        : 'PromotionsBanner'

      const slidesArray = ['AuditsBanner', 'InhouseAdsBanner']

      if (isOfTypeDealer.value || isAdmin.value) {
        slidesArray.push('PerksBanner', dynamicDealerBanner)
      } else {
        slidesArray.push('PromotionsBanner', 'FinanceBanner')
      }

      slides.value = [...shuffleArray(slidesArray)]
    })

    const recordPopularityEvent = (bannerName: string, popularityEventName) => {
      if (recordedPopularityEvents.value.includes(popularityEventName)) {
        return
      }
      popularityService.recordEvent(popularityEventName, {
        user_type: userState.type,
        user_id: userState.id,
        banner_name: bannerName
      })

      recordedPopularityEvents.value.push(popularityEventName)
    }

    return {
      sliderRef,
      bannerClick,
      slideClasses,
      isMobile,
      slides,
      isSingleOrAnon,
      recordPopularityEvent
    }
  }
})
